import { Component, Input } from '@angular/core';

@Component({
	selector: 'app-avatar',
	templateUrl: './avatar.component.html',
	styleUrls: ['./avatar.component.css'],
})
export class AvatarComponent {
	@Input() name: string | null = null;
	@Input() fname: string | null = null;
	@Input() lname: string | null = null;
	@Input() initials: string | null = null;
	@Input() size: 'sm' | 'md' | 'lg' | 'xl' = 'md';

	private static readonly PALETTE: { bg: string; text: string }[] = [
		{ bg: '#E8F4FD', text: '#1E5A96' },
		{ bg: '#E8F5E9', text: '#2E7D32' },
		{ bg: '#FFF3E0', text: '#E65100' },
		{ bg: '#F3E5F5', text: '#7B1FA2' },
		{ bg: '#FCE4EC', text: '#C2185B' },
		{ bg: '#E0F2F1', text: '#00695C' },
		{ bg: '#FFF8E1', text: '#F9A825' },
		{ bg: '#E8EAF6', text: '#3949AB' },
		{ bg: '#EFEBE9', text: '#5D4037' },
		{ bg: '#E1F5FE', text: '#0277BD' },
	];

	getDisplayInitials(): string {
		if (this.initials != null && this.initials.trim() !== '') {
			return this.initials.trim().slice(0, 2).toUpperCase();
		}
		if (this.name != null && this.name.trim() !== '') {
			const parts = this.name.trim().split(/\s+/);
			const first = parts[0]?.charAt(0)?.toUpperCase() ?? '';
			const last = parts.length > 1 ? (parts[parts.length - 1]?.charAt(0)?.toUpperCase() ?? '') : '';
			return (first + last) || '?';
		}
		const f = (this.fname ?? '').trim();
		const l = (this.lname ?? '').trim();
		const first = f.charAt(0)?.toUpperCase() ?? '';
		const last = l.charAt(0)?.toUpperCase() ?? '';
		return (first + last) || '?';
	}

	getColors(): { backgroundColor: string; color: string } {
		const str = this.getDisplayInitials();
		const index = this.hashToIndex(str);
		const pair = AvatarComponent.PALETTE[index];
		return {
			backgroundColor: pair.bg,
			color: pair.text,
		};
	}

	private hashToIndex(s: string): number {
		if (!s.length) return 0;
		let h = 0;
		for (let i = 0; i < s.length; i++) {
			h = (h * 31 + s.charCodeAt(i)) >>> 0;
		}
		return h % AvatarComponent.PALETTE.length;
	}
}
